import { Injectable } from '@angular/core';
import { CONSUMPTION_FILTER_TYPES } from '../../const/consumption.const';
import { ADMIN_SERVICES, PREDICTION_SERVICES } from '../../const/http.const';
import {
  IAbsoluteError,
  IClientResponse,
  IComplexFilter,
  IComplexFilterResponse,
  IDataCityGate,
  IDataClient,
  IPredictionStatusResponse,
  SeasonalDetailRC,
  TransformedDataItem,
} from '../../interfaces/prediction.interface';
import { AppSettings } from '../../utils/app.settings';
import { HttpService } from '../http/http.service';
import { standartResponse } from '../../interfaces/standar-prediction.interface';
import {
  ConsumptionsByYear,
  IResponse,
} from '../../interfaces/seasonal-prediction.interface';
import { finalize, Observable } from 'rxjs';
import { EnovaLoadingComponent } from '../../utils/enova-loading/enova-loading.component';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { ISociedad } from '../../interfaces/societies.interface';

@Injectable({
  providedIn: 'root',
})
export class PredictionService {
  weekDays: string[] = [
    'Lunes',
    'Martes',
    'Miercoles',
    'Jueves',
    'Viernes',
    'Sabado',
    'Domingo',
  ];

  constructor(
    private http: HttpService,
    private appSetting: AppSettings,
    private dialog: MatDialog,
    private httpClient: HttpClient
  ) {}

  //Filtros General
  async getGeneralFilterOptions(): Promise<IComplexFilter[]> {
    let generalFilter: IComplexFilter[] = [];

    const url: string = `${this.appSetting.adminURL}/${ADMIN_SERVICES.COMPLEX_FILTERS}`;
    const response: IComplexFilterResponse = (await this.http.getService(
      url
    )) as IComplexFilterResponse;

    Object.keys(response).forEach(key => {
      generalFilter.push({
        filterLabel: CONSUMPTION_FILTER_TYPES[key],
        filterInfo: response[key],
        filterName: key,
      });
    });
    return generalFilter;
  }

  //Filtros clientes

  async getClientFilterOptions(params: string = ''): Promise<any[]> {
    const url: string = `${this.appSetting.adminURL}/${ADMIN_SERVICES.COMPLEX_FILTERS}/clientes?${params}`;
    const response: any = (await this.http.getService(url)) as any[];
    return response[0].clientes;
  }

  //Filtros Puntos

  async getCityGatesFilterOptions(params: string = ''): Promise<any[]> {
    const url: string = `${this.appSetting.adminURL}/${ADMIN_SERVICES.COMPLEX_FILTERS}/city-gates?${params}`;
    const response: any = (await this.http.getService(url)) as any[];
    return response;
  }

  // Desviación Predicción vs Real Home

  async getDesviacionMercado() {
    const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/deviation/real`;
    const response: any = (await this.http.getService(url)) as any[];
    return response;
  }

  //% Desviación vs. Modelo aplicado
  getDesviacionStandar(
    startDate: string,
    endDate: string,
    filters: string = ''
  ) {
    const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/deviation?fechaInicio=${startDate}&fechaFin=${endDate}&${filters}`;
    return this.httpClient.get(url);
  }

  // Modelos de predicción vs. real grafica
  getPrediccion(startDate: string, endDate: string, filters: string = '') {
    const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/real?fechaInicio=${startDate}&fechaFin=${endDate}&${filters}`;
    return this.httpClient.get(url);
  }

  // Error Absoluto Medio (Desviación Prediccion vs real)

  getErrorAbsolutoMedio(
    startDate: string,
    endDate: string,
    filters: string = ''
  ) {
    const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/real/mape?fechaInicio=${startDate}&fechaFin=${endDate}&${filters}`;
    return this.httpClient.get(url);
  }

  transformErrorData(data: IAbsoluteError[]) {
    const newInfo: any = [];
    data.map((item: any) => {
      const newEntry: any = {
        ...item,
        date: item.fecha,
        day: this.weekDays[new Date(item.fecha).getDay()],
      };
      newInfo.push(newEntry);
    });
    return newInfo;
  }

  // Obtener Clientes para Estado de Predicción

  getClientsForPrediction(
    startDate: string,
    endDate: string,
    filters?: string
  ): Observable<IClientResponse> {
    const url: string = `${this.appSetting.predictionURL}/${
      PREDICTION_SERVICES.CALENDAR_PREDICTION
    }/clients?fechaInicio=${startDate}&fechaFin=${endDate}${
      filters ? `&${filters}` : ''
    }`;
    const response = this.httpClient.get<IClientResponse>(url);
    return response;
  }

  //Transformar datos para tabla de Clientes

  transformClientData(data: IDataClient[]) {
    const newInfo: any = [];
    data.map((item: any) => {
      const newEntry: any = {
        fecha: item.fecha,
        day: this.weekDays[new Date(item.fecha).getDay()],
        percent: `${item.porcentajePrediccion}%`,
      };
      item.data.forEach((opt: IDataClient) => {
        const client = opt.cliente.replace(/\./g, ' ');
        // Mantener el valor tal como viene del backend
        let mppValue: any = opt.mpp;
        if (mppValue !== null && mppValue !== undefined) {
          // Si es string, convertirlo a número primero
          if (typeof mppValue === 'string') {
            mppValue = parseFloat(
              mppValue.replace(/\./g, '').replace(',', '.')
            );
          }
          // Mantener el valor sin formateo adicional
          mppValue = mppValue.toString();
        }
        newEntry[client] = {
          mpp: mppValue,
          uuid: opt.uuid, // Incluir el UUID del cliente (prediccionUuid)
          fecha: opt.fecha,
          cliente: opt.cliente,
        };
      });
      newInfo.push(newEntry);
    });
    return newInfo;
  }

  //Objtener Puntos de Salida para Estado de Predicción

  getCityGatesForPrediction(
    startDate: string,
    endDate: string,
    filters?: string
  ): Observable<IClientResponse> {
    const url: string = `${this.appSetting.predictionURL}/${
      PREDICTION_SERVICES.CALENDAR_PREDICTION
    }/city-gates?fechaInicio=${startDate}&fechaFin=${endDate}${
      filters ? `&${filters}` : ''
    }`;
    const response = this.httpClient.get<IClientResponse>(url);
    return response;
  }

  transformCityGateData(data: IDataCityGate[]) {
    const newInfo: any = [];
    data.map((item: any) => {
      const newEntry: any = {
        date: item.fecha,
        day: this.weekDays[new Date(item.fecha).getDay()],
        percent: `${item.porcentajePrediccion}%`,
      };
      item.data.forEach((opt: IDataCityGate) => {
        const cityGate = opt.puntoSalida.replace(/\./g, ' ');
        newEntry[cityGate] = {
          mpp: opt.mpp,
          puntoSalidaUuid: (opt as any).puntoSalidaUuid || (opt as any).uuid, // Incluir UUID si está disponible
          fecha: opt.fecha,
          puntoSalida: opt.puntoSalida,
        };
      });
      newInfo.push(newEntry);
    });
    return newInfo;
  }

  // Get Prediction Status

  async getPredictionStatus(date: string) {
    const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/traffic-light?fecha=${date}`;
    try {
      const response = (await this.http.getService(
        url
      )) as IPredictionStatusResponse[];
      return response;
    } catch (error) {
      return [];
      // console.error('Error in get service method:',error);
      // throw error;
    }
  }

  transformPredictionStatus(
    dataInicial: IPredictionStatusResponse[],
    markets: ISociedad[]
  ) {
    const sociedadesMap = markets.filter(sociedad =>
      dataInicial.some(data => data.sociedadCom === sociedad.uuid)
    );
    const sociedades: any = {};
    sociedadesMap.forEach((sociedad: any) => {
      sociedades[sociedad.uuid] = sociedad.sigla.toLowerCase();
    });

    const outputData: any[] = [];

    dataInicial.forEach((entry: any) => {
      const market = sociedades[entry.sociedadCom];
      if (market) {
        if (outputData.length === 0) {
          outputData.push({ label: 'Clientes con predicción' });
          outputData.push({ label: 'Clientes activos predicción' });
          outputData.push({ label: 'Diferencia' });
        }
        outputData[0][market] =
          parseInt(entry.clientesPrediccion as string, 10) || 0;
        outputData[1][market] = entry.clientesActivoPrediccion;
        outputData[2][market] = `${parseFloat(entry.diferencia.toFixed(2))}%`;
      }
    });

    return outputData;
  }

  transformPredictionLights(
    data: IPredictionStatusResponse[],
    markets: ISociedad[]
  ) {
    const sociedadesMap = markets.filter(sociedad =>
      data.some(d => d.sociedadCom === sociedad.uuid)
    );
    const sociedades: any = {};
    sociedadesMap.forEach((sociedad: any) => {
      sociedades[sociedad.uuid] = sociedad.sigla.toLowerCase();
    });
    const outputData: any[] = [];
    data.forEach((entry: IPredictionStatusResponse) => {
      const market = sociedades[entry.sociedadCom];
      outputData.push({
        market: market,
        diferencia: entry.diferencia,
      });
    });
    return outputData;
  }

  // DESVIACION ESTANDAR

  async getDataStandartPrediction(
    startDate: string,
    endDate: string,
    filters: string = ''
  ) {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/standard?fechaInicio=${startDate}&fechaFin=${endDate}&${filters}`;
      const response: any = (await this.http.getService(
        url
      )) as standartResponse[];
      const transformData = await this.transformStandarData(response);
      return transformData;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async getDataStandartPredictionWithBase(data: any) {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/standard/edit`;
      const response: any = (await this.http.postService(
        url,
        data
      )) as standartResponse[];
      const transformData = await this.transformStandarData(response);
      return transformData;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async getDataWithBase(uuid: string) {
    const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/standard/temporal?uuid=${uuid}`;
    const response: any = (await this.http.getService(url)) as any[];
    return response;
  }

  async getDetailStandarPrediction(
    fecha: string,
    baseCalculo: number,
    filters: { [key: string]: string[] },
    clientId: string | number
  ) {
    let result = '';

    if (filters && typeof filters === 'object') {
      result = Object.entries(filters)
        .filter(([key]) => key !== 'idMedidor') // Exclude idMedidor from filters as it's handled separately
        .map(([key, values]) => {
          if (Array.isArray(values)) {
            return values.map(value => `&${key}=${value}`).join('');
          } else if (values) {
            return `&${key}=${values}`;
          }
          return '';
        })
        .join('');
    }

    // Convert clientId to number and validate
    let clientIdParam = '';
    if (clientId !== null && clientId !== undefined && clientId !== '') {
      const numericClientId =
        typeof clientId === 'string' ? parseInt(clientId, 10) : clientId;
      if (!isNaN(numericClientId)) {
        clientIdParam = `&idMedidor=${numericClientId}`;
      }
    }

    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/standard/detail?fecha=${fecha}&baseCalculo=${baseCalculo}${result}${clientIdParam}`;
      const response: any = (await this.http.getService(url)) as any[];

      if (response) {
        const transformData = await this.transformPredictionDetail(response);
        return transformData;
      } else {
        return {
          udc: { basicInfo: [], total: 0 },
          pudc: { basicInfo: [], total: 0 },
          rcdtac: { basicInfo: [], total: 0 },
          dtac: { basicInfo: [], total: 0 },
          rcudc: { basicInfo: [], total: 0 },
        };
      }
    } catch (error) {
      console.error('Error in getDetailStandarPrediction:', error);
      return {
        udc: { basicInfo: [], total: 0 },
        pudc: { basicInfo: [], total: 0 },
        rcdtac: { basicInfo: [], total: 0 },
        dtac: { basicInfo: [], total: 0 },
        rcudc: { basicInfo: [], total: 0 },
      };
    }
  }

  formatNumber = (value: number): string => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: false, // No usar separadores de miles
    }).format(value);
  };

  // ✅ Nueva función para formato colombiano con separadores de miles
  formatNumberColombian = (value: number): string => {
    if (value === null || value === undefined || isNaN(value)) {
      return '0,00';
    }

    // Formatear con 2 decimales
    const numberStr = value.toFixed(2);
    const parts = numberStr.split('.');

    // Agregar separadores de miles (puntos) cada 3 dígitos
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Unir con coma como separador decimal
    return parts[0] + ',' + parts[1];
  };

  async transformPredictionDetail(data: any) {
    try {
      const transformSection = (section: any, type?: string) => {
        let basicInfo = [];

        const safeToFixed = (num: any, decimals: number) => {
          if (num === null) return '-';
          return parseFloat(num).toFixed(decimals);
        };

        const safeRC = (num: any) => {
          const numberValue = parseFloat(num);
          return !isNaN(numberValue)
            ? `${(numberValue * 100).toFixed(2)}%` // ✅ Cambio a 2 decimales
            : '';
        };

        if (type === 'rcdtac') {
          // ✅ RC DTAC - usar formato colombiano para consumo y ref
          basicInfo =
            section.rcDates && Array.isArray(section.rcDates)
              ? section.rcDates.map((date: string, index: number) => ({
                  day: this.capitalizeText(section.typicDate?.dia || ''),
                  date: this.formatDateDetail(date),
                  tag: this.capitalizeText(
                    section.consumDatesInfo?.[index]?.etiquetaName || ''
                  ),
                  consumo: this.formatNumberColombian(
                    section.consumRcDates?.[index] || 0
                  ), // ✅ Formato colombiano
                  ref: this.formatNumberColombian(
                    section.consumrRefDate?.[index] || 0
                  ), // ✅ Formato colombiano
                  RC: safeRC(section.rcs?.[index]),
                  percent:
                    section.rcs?.[index] !== null ? section.rcs?.[index] : '',
                }))
              : [];
        } else if (type === 'dtac') {
          // ✅ DTAC - usar formato colombiano para consumo
          // ✅ DTAC siempre debe mostrar "Día Típico" independientemente de los datos del backend
          basicInfo = [
            {
              day: this.capitalizeText(section.typicDate?.dia || ''),
              date: this.formatDateDetail(section.typicDate?.fecha || ''),
              tag: 'Día Típico', // ✅ Forzar siempre "Día Típico" para DTAC
              consumo: this.formatNumberColombian(
                section.typicDate?.consumoTypicDay || 0
              ), // ✅ Formato colombiano
            },
          ];
        } else if (type === 'rcudc') {
          // ✅ RC UDC - usar formato colombiano para consumo y ref
          basicInfo =
            section.rcDates && Array.isArray(section.rcDates)
              ? section.rcDates.map((date: string, index: number) => ({
                  day: this.capitalizeText(
                    section.consumDatesInfo?.[index]?.dia || ''
                  ),
                  date: this.formatDateDetail(date),
                  tag: this.capitalizeText(
                    section.consumDatesInfo?.[index]?.etiquetaName || ''
                  ),
                  consumo: this.formatNumberColombian(
                    section.consumRcDates?.[index] || 0
                  ), // ✅ Formato colombiano
                  ref: this.formatNumberColombian(
                    section.consumrRefDate?.[index] || 0
                  ), // ✅ Formato colombiano
                  RC: safeRC(section.rcs?.[index]),
                  percent:
                    section.rcs?.[index] !== null ? section.rcs?.[index] : '',
                }))
              : [];
        } else {
          // ✅ UDC y PUDC - usar formato colombiano para consumo
          basicInfo = Array.isArray(section.consumDatesInfo)
            ? section.consumDatesInfo.map((info: any, index: number) => ({
                day: this.capitalizeText(info?.dia || ''),
                date: this.formatDateDetail(info?.fechaConsumoDate || ''),
                tag: this.capitalizeText(info?.etiquetaName || ''),
                consumo: this.formatNumberColombian(
                  section.consumValues?.[index] || 0
                ), // ✅ Formato colombiano
              }))
            : section.consumDateInfo
              ? [
                  {
                    day: this.capitalizeText(section.consumDateInfo?.dia || ''),
                    date: this.formatDateDetail(
                      section.consumDateInfo?.fechaConsumoDate || ''
                    ),
                    tag: this.capitalizeText(
                      section.consumDateInfo?.etiquetaName || ''
                    ),
                    consumo: this.formatNumberColombian(
                      section.consumValue || 0
                    ), // ✅ Formato colombiano
                  },
                ]
              : [];
        }
        return {
          basicInfo: basicInfo,
          total: section.predictionMbtu || 0,
        };
      };

      return {
        udc: data.udc
          ? transformSection(data.udc)
          : { basicInfo: [], total: 0 },
        pudc: data.pudc
          ? transformSection(data.pudc)
          : { basicInfo: [], total: 0 },
        rcdtac: data.rcdtac
          ? transformSection(data.rcdtac, 'rcdtac')
          : { basicInfo: [], total: 0 },
        dtac: data.rcdtac
          ? transformSection(data.rcdtac, 'dtac')
          : { basicInfo: [], total: 0 },
        rcudc: data.rcudc
          ? transformSection(data.rcudc, 'rcudc')
          : { basicInfo: [], total: 0 },
      };
    } catch (error) {
      console.error('Error transforming prediction detail:', error);
      return {
        udc: { basicInfo: [], total: 0 },
        pudc: { basicInfo: [], total: 0 },
        rcdtac: { basicInfo: [], total: 0 },
        dtac: { basicInfo: [], total: 0 },
        rcudc: { basicInfo: [], total: 0 },
      };
    }
  }

  async transformStandarData(data: any) {
    if (!data) {
      return [];
    }

    if (!Array.isArray(data)) {
      if (typeof data === 'object' && data !== null) {
        return [
          {
            fecha: data.fecha,
            dia: this.capitalizeText(data.dia),
            etiqueta: this.capitalizeText(data.etiqueta),
            udc: this.transformPreductionValue(data.udc),
            pudc: this.transformPreductionValue(data.pudc),
            rcdtac: this.transformPreductionValue(data.rcdtac),
            rcudc: this.transformPreductionValue(data.rcudc),
            mpp: this.transformPreductionValue(data.mpp),
          },
        ];
      }
      return [];
    }

    return data
      .filter(item => item && typeof item === 'object')
      .map((item: any) => {
        return {
          fecha: item.fecha,
          dia: this.capitalizeText(item.dia),
          etiqueta: this.capitalizeText(item.etiqueta),
          udc: this.transformPreductionValue(item.udc),
          pudc: this.transformPreductionValue(item.pudc),
          rcdtac: this.transformPreductionValue(item.rcdtac),
          rcudc: this.transformPreductionValue(item.rcudc),
          mpp: this.transformPreductionValue(item.mpp),
        };
      });
  }

  transformPreductionValue(value: number) {
    if (!value) return value;
    return parseFloat(value.toFixed(3));
  }

  capitalizeText(text: string) {
    if (!text || typeof text !== 'string') return text || '';
    return text
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  getGrapDataPrediction(data: any[]) {
    data.sort((a, b) => {
      return new Date(a.fecha).getTime() - new Date(b.fecha).getTime();
    });

    // const itemsToReturn: any[] = data.slice(0, 7);
    const itemsToReturn: any[] = data;
    const dataGraph = this.groupByPrediction(itemsToReturn);

    const labels = itemsToReturn.map(item => item.fecha);
    return {
      labels: labels,
      data: dataGraph,
    };
  }

  groupByPrediction(datos: any[]): {
    [campo: string]: { fecha: string; valor: number }[];
  } {
    const resultado: { [campo: string]: { fecha: string; valor: number }[] } =
      {};

    datos.forEach(item => {
      Object.keys(item).forEach(key => {
        if (key !== 'dia' && key !== 'etiqueta' && key !== 'fecha') {
          if (!resultado[key]) {
            resultado[key] = [];
          }
          resultado[key].push({
            fecha: item.fecha,
            valor: item[key as keyof any],
          });
        }
      });
    });

    return resultado;
  }

  async generatePrediction(data: any) {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/standard/generate`;
      const response: any = (await this.http.postService(url, data)) as any[];

      if (Object.keys(response)) {
        const maxRetryTime = 900000;
        const retryInterval = 30000;
        // const maxRetryTime = 120000;
        // const retryInterval = 5000;
        const startTime = Date.now();

        while (true) {
          const getData = await this.getDataWithBase(response.uuid);

          // if (!Array.isArray(getData)) {
          if (getData.length > 0) {
            PREDICTION_SERVICES;
            return getData;
          }

          const elapsedTime = Date.now() - startTime;
          if (elapsedTime >= maxRetryTime) {
            throw new Error('Max retry time of 2 minutes exceeded.');
          }

          await new Promise(resolve => setTimeout(resolve, retryInterval));
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  //Predicción Estacional

  async getDataSeasonalPrediction(
    startDate: string,
    endDate: string,
    uuid: string,
    filters: string = ''
  ) {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal?fechaInicio=${startDate}&fechaFin=${endDate}&uuid=${uuid}&${filters}`;
      const response: any = (await this.http.getService(
        url
      )) as standartResponse[];
      const transformData = await this.transformStandarData(response);
      return transformData;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  private buildFilterParams(filters: { [key: string]: string[] }): string {
    const params: string[] = [];

    Object.entries(filters).forEach(([key, values]) => {
      if (Array.isArray(values)) {
        values.forEach(value => {
          if (value && value.trim() !== '') {
            params.push(`${key}=${encodeURIComponent(value)}`);
          }
        });
      } else if (values !== null && values !== undefined && values !== '') {
        params.push(`${key}=${encodeURIComponent(String(values))}`);
      }
    });

    const result = params.join('&');
    return result;
  }

  async getHollyWeekDetail(
    startDate: string,
    endDate: string,
    baseCalculo: number,
    filters?: { [key: string]: string[] }
  ) {
    try {
      let url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/holyweek/detail?fechaInicio=${startDate}&fechaFin=${endDate}&&baseCalculo=${baseCalculo}`;

      // Agregar filtros a la URL si existen
      if (filters && Object.keys(filters).length > 0) {
        const filterParams = this.buildFilterParams(filters);
        if (filterParams) {
          url += `&${filterParams}`;
        }
      }

      const response: any = (await this.http.getService(url)) as any[];
      const transformData = await this.transformHollyWeekDetail(response);
      return transformData;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  async getRecessWeekDetail(
    startDate: string,
    endDate: string,
    baseCalculo: number,
    filters?: { [key: string]: string[] }
  ) {
    try {
      let url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/recessweek/detail?fechaInicio=${startDate}&fechaFin=${endDate}&&baseCalculo=${baseCalculo}`;

      // Agregar filtros a la URL si existen
      if (filters && Object.keys(filters).length > 0) {
        const filterParams = this.buildFilterParams(filters);
        if (filterParams) {
          url += `&${filterParams}`;
        }
      }

      const response: any = (await this.http.getService(url)) as any[];
      const transformData = await this.transformHollyWeekDetail(response);
      return transformData;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  async transformHollyWeekDetail(data: any) {
    try {
      const consumeDataUDC: any[] = [];
      const consumeDataPUDC: any[] = [];
      const udc = data.udc;

      udc.forEach((item: any) => {
        const year = new Date(item.consumDate).getUTCFullYear();
        const predictionYear = new Date(item.predictionDate).getUTCFullYear();
        const day = this.capitalizeText(item.consumDateInfo.dia);

        consumeDataUDC.push({
          [`dia${year}`]: day,
          [`fecha${year}`]: this.formatDateDetail(item.consumDate),
          [`consumo${year}`]: item.consumValue.toFixed(3),
          [`dia${predictionYear}`]: day,
          [`fecha${predictionYear}`]: this.formatDateDetail(
            item.predictionDate
          ),
          [`consumo${predictionYear}`]: item.predictionMbtu.toFixed(3),
        });
      });

      data.pudc.forEach((item: any) => {
        const row: any = {};
        item.consumDates.forEach((date: string, index: number) => {
          const year = new Date(date).getFullYear().toString();
          row[`dia${year}`] = this.capitalizeText(
            item.consumDatesInfo[index].dia
          );
          row[`fecha${year}`] = this.formatDateDetail(date);
          row[`consumo${year}`] = item.consumValues[index].toFixed(3);
        });

        const predictionYear = new Date(item.predictionDate)
          .getFullYear()
          .toString();
        row[`dia${predictionYear}`] = item.consumDatesInfo[0].dia;
        row[`fecha${predictionYear}`] = this.formatDateDetail(
          item.predictionDate
        );
        row[`consumo${predictionYear}`] = item.predictionMbtu.toFixed(3);

        consumeDataPUDC.push(row);
      });

      const consumeDataRCDTAC = this.transformInfo(data.rcdtac);
      const previousWeekRCDTAC = this.transformTypicDate(data.rcdtac);
      const rcRCDTAC = this.transformRC(data.rcdtac);
      const consumeDataRCUDC = this.transformInfo(data.rcudc);
      const rcUDC = this.transformRC(data.rcudc);
      const consumRef = this.transformconsumrRef(data.rcudc);

      return {
        udc: {
          consumos: consumeDataUDC,
        },
        pudc: {
          consumos: consumeDataPUDC,
        },
        rcdtac: {
          consumos: consumeDataRCDTAC,
          previousWeek: previousWeekRCDTAC,
          rc: rcRCDTAC,
        },
        rcudc: {
          consumos: consumeDataRCUDC,
          rc: rcUDC,
          consumRef: consumRef,
        },
      };
    } catch (error) {
      console.error('Error transforming prediction detail:', error);
      return {
        udc: { consumos: [] },
        pudc: { consumos: [] },
        rcdtac: { consumos: [] },
        dtac: { consumos: [] },
        rcudc: { consumos: [] },
      };
    }
  }

  private formatDateDetail(date: string): string {
    const parsedDate = new Date(date);
    const day = String(parsedDate.getUTCDate()).padStart(2, '0');
    const month = String(parsedDate.getUTCMonth() + 1).padStart(2, '0');
    const year = parsedDate.getUTCFullYear();
    return `${day}-${month}-${year}`;
  }

  transformInfo = (data: any) => {
    const dataTransform: any[] = [];
    data.forEach((item: any) => {
      const row: any = {};
      item.rcDates.forEach((date: string, index: number) => {
        const year = new Date(date).getFullYear().toString();
        row[`dia${year}`] = this.capitalizeText(
          item.consumDatesInfo[index].dia
        );
        row[`fecha${year}`] = this.formatDateDetail(date);
        row[`consumo${year}`] = item.consumRcDates[index]
          ? item.consumRcDates[index].toFixed(3)
          : null;
      });

      const predictionYear = new Date(item.predictionDate)
        .getFullYear()
        .toString();
      row[`dia${predictionYear}`] = this.capitalizeText(
        item.consumDatesInfo[0].dia
      );
      row[`fecha${predictionYear}`] = this.formatDateDetail(
        item.predictionDate
      );
      row[`consumo${predictionYear}`] = item.predictionMbtu
        ? item.predictionMbtu.toFixed(3)
        : null;

      dataTransform.push(row);
    });

    return dataTransform;
  };

  transformRC = (data: SeasonalDetailRC[]): TransformedDataItem[] => {
    return data.map(item => {
      const transformedItem: TransformedDataItem = {};

      item.rcDates.forEach((date, index) => {
        const year = new Date(date).getFullYear();
        transformedItem[`dia${year}`] = this.capitalizeText(
          item.consumDatesInfo[index].dia
        );
        transformedItem[`fecha${year}`] = this.formatDateDetail(date);
        transformedItem[`consumo${year}`] = item.rcs[index]
          ? item.rcs[index].toFixed(3)
          : null;
      });

      return transformedItem;
    });
  };

  transformconsumrRef = (data: SeasonalDetailRC[]): TransformedDataItem[] => {
    return data.map(item => {
      const transformedItem: TransformedDataItem = {};

      item.rcDates.forEach((date, index) => {
        const year = new Date(date).getFullYear();
        transformedItem[`dia${year}`] = this.capitalizeText(
          item.consumDatesInfo[index].dia
        );
        transformedItem[`fecha${year}`] = this.formatDateDetail(date);
        transformedItem[`consumo${year}`] = item.consumrRefDate[index]
          ? item.consumrRefDate[index].toFixed(3)
          : null;
      });

      return transformedItem;
    });
  };

  getDayName(dateString: string) {
    const date = new Date(dateString);
    const days = [
      'domingo',
      'lunes',
      'martes',
      'miércoles',
      'jueves',
      'viernes',
      'sábado',
    ];
    return days[date.getDay()];
  }

  transformTypicDate = (data: any) => {
    const newValues = data
      .map((item: any) => {
        return {
          ...item.typicDate,
          dia: this.capitalizeText(item.typicDate.dia),
        };
      })
      .sort((a: any, b: any) => {
        return new Date(b.fecha).getTime() - new Date(a.fecha).getTime();
      });

    return newValues;
  };

  async getDataSeasonalPredictionWithBase(data: any): Promise<any[]> {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/edit`;
      const response: any = (await this.http.postService(
        url,
        data
      )) as standartResponse[];
      const transformData = await this.transformStandarData(response);
      return transformData;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async generatePredictionHollyWeek(data: any) {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/holyweek/generate`;
      const response: any = (await this.http.postService(url, data)) as any[];
      if (Object.keys(response)) {
        const maxRetryTime = 120000;
        const retryInterval = 5000;
        const startTime = Date.now();

        while (true) {
          const getData = await this.getDataWithBase(response.uuid);

          if (!Array.isArray(getData)) {
            return getData;
          }

          const elapsedTime = Date.now() - startTime;
          if (elapsedTime >= maxRetryTime) {
            throw new Error('Max retry time of 2 minutes exceeded.');
          }

          await new Promise(resolve => setTimeout(resolve, retryInterval));
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async generatePredictionRecessWeek(data: any) {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/recessweek/generate`;
      const response: any = (await this.http.postService(url, data)) as any[];
      if (Object.keys(response)) {
        const maxRetryTime = 120000;
        const retryInterval = 5000;
        const startTime = Date.now();

        while (true) {
          const getData = await this.getDataWithBase(response.uuid);

          if (!Array.isArray(getData)) {
            return getData;
          }

          const elapsedTime = Date.now() - startTime;
          if (elapsedTime >= maxRetryTime) {
            throw new Error('Max retry time of 2 minutes exceeded.');
          }

          await new Promise(resolve => setTimeout(resolve, retryInterval));
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async generatePredictionEndYear(data: any) {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/endyear/generate`;
      const response: any = (await this.http.postService(url, data)) as any[];
      if (Object.keys(response)) {
        return response;
        // const maxRetryTime = 120000;
        // const retryInterval = 5000;
        // const startTime = Date.now();

        // while (true) {
        //   const getData = await this.getDataWithBase(response.uuid);

        //   if (!Array.isArray(getData)) {
        //     return getData;
        //   }

        //   const elapsedTime = Date.now() - startTime;
        //   if (elapsedTime >= maxRetryTime) {
        //     throw new Error('Max retry time of 2 minutes exceeded.');
        //   }

        //   await new Promise((resolve) => setTimeout(resolve, retryInterval));
        // }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getDataSeasonalHollyWeekPredictionWithBase(data: any) {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/holyweek/edit`;
      const response: any = (await this.http.postService(url, data)) as any[];

      if (!response || !response.uuid) {
        throw new Error('No se pudo obtener el UUID de la predicción');
      }

      const maxRetryTime = 120000;
      const retryInterval = 5000;
      const startTime = Date.now();

      while (true) {
        const getData = await this.getDataWithBase(response.uuid);

        // Verificar si el objeto está vacío o no tiene propiedades
        if (
          !getData ||
          getData === null ||
          getData === undefined ||
          (typeof getData === 'object' && Object.keys(getData).length === 0) ||
          (Array.isArray(getData) && getData.length === 0)
        ) {
          const elapsedTime = Date.now() - startTime;
          if (elapsedTime >= maxRetryTime) {
            throw new Error('Max retry time of 2 minutes exceeded.');
          }
          await new Promise(resolve => setTimeout(resolve, retryInterval));
          continue;
        }

        if (!Array.isArray(getData)) {
          const transformData = await this.transformStandarData(getData);
          if (transformData && transformData.length > 0) {
            return transformData;
          }
        } else if (getData.length > 0) {
          return getData;
        }

        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= maxRetryTime) {
          throw new Error('Max retry time of 2 minutes exceeded.');
        }

        await new Promise(resolve => setTimeout(resolve, retryInterval));
      }
    } catch (error) {
      console.error(
        'Error en getDataSeasonalHollyWeekPredictionWithBase:',
        error
      );
      throw error;
    }
  }

  async getDataSeasonalRecessWeekWithBase(data: any) {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/recessweek/edit`;
      const response: any = (await this.http.postService(url, data)) as any[];

      if (!response || !response.uuid) {
        throw new Error('No se pudo obtener el UUID de la predicción');
      }

      const maxRetryTime = 120000;
      const retryInterval = 5000;
      const startTime = Date.now();

      while (true) {
        const getData = await this.getDataWithBase(response.uuid);

        if (getData) {
          if (!Array.isArray(getData)) {
            const transformData = await this.transformStandarData(getData);
            if (transformData && transformData.length > 0) {
              return transformData;
            }
          } else if (getData.length > 0) {
            return getData;
          }
        }

        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= maxRetryTime) {
          throw new Error('Max retry time of 2 minutes exceeded.');
        }

        await new Promise(resolve => setTimeout(resolve, retryInterval));
      }
    } catch (error) {
      console.error('Error en getDataSeasonalRecessWeekWithBase:', error);
      throw error;
    }
  }

  async getDataSeasonalVacationWithBase(data: any) {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/vacation/edit`;
      const response: any = (await this.http.postService(url, data)) as any[];

      if (!response || !response.uuid) {
        throw new Error('No se pudo obtener el UUID de la predicción');
      }

      const maxRetryTime = 120000;
      const retryInterval = 5000;
      const startTime = Date.now();

      while (true) {
        const getData = await this.getDataWithBase(response.uuid);

        if (getData) {
          if (!Array.isArray(getData)) {
            const transformData = await this.transformStandarData(getData);
            if (transformData && transformData.length > 0) {
              return transformData;
            }
          } else if (getData.length > 0) {
            return getData;
          }
        }

        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= maxRetryTime) {
          throw new Error('Max retry time of 2 minutes exceeded.');
        }

        await new Promise(resolve => setTimeout(resolve, retryInterval));
      }
    } catch (error) {
      console.error('Error en getDataSeasonalVacationWithBase:', error);
      throw error;
    }
  }

  async getDataSeasonalEndYearWithBase(data: any) {
    try {
      const url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/endyear/edit`;
      const response: any = (await this.http.postService(url, data)) as any[];

      if (!response || !response.uuid) {
        throw new Error('No se pudo obtener el UUID de la predicción');
      }

      const maxRetryTime = 120000;
      const retryInterval = 5000;
      const startTime = Date.now();

      while (true) {
        const getData = await this.getDataWithBase(response.uuid);

        if (getData) {
          if (!Array.isArray(getData)) {
            const transformData = await this.transformStandarData(getData);
            if (transformData && transformData.length > 0) {
              return transformData;
            }
          } else if (getData.length > 0) {
            return getData;
          }
        }

        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= maxRetryTime) {
          throw new Error('Max retry time of 2 minutes exceeded.');
        }

        await new Promise(resolve => setTimeout(resolve, retryInterval));
      }
    } catch (error) {
      console.error('Error en getDataSeasonalEndYearWithBase:', error);
      throw error;
    }
  }

  async getVacationsDetail(
    startDate: string,
    endDate: string,
    baseCalculo: number,
    filters?: { [key: string]: string[] }
  ) {
    try {
      let url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/vacation/detail?fechaInicio=${startDate}&fechaFin=${endDate}&&baseCalculo=${baseCalculo}`;

      // Agregar filtros a la URL si existen
      if (filters && Object.keys(filters).length > 0) {
        const filterParams = this.buildFilterParams(filters);
        if (filterParams) {
          url += `&${filterParams}`;
        }
      }

      const response: any = (await this.http.getService(url)) as any[];
      const transformData = await this.transformVacationsDetail(response);

      return transformData;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  async getEndYearDetail(
    startDate: string,
    endDate: string,
    baseCalculo: number,
    filters?: { [key: string]: string[] }
  ) {
    try {
      let url: string = `${this.appSetting.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal/endyear/detail?fechaInicio=${startDate}&fechaFin=${endDate}&&baseCalculo=${baseCalculo}`;

      // Agregar filtros a la URL si existen
      if (filters && Object.keys(filters).length > 0) {
        const filterParams = this.buildFilterParams(filters);
        if (filterParams) {
          url += `&${filterParams}`;
        }
      }

      const response: any = (await this.http.getService(url)) as any[];

      // Validación básica de la respuesta
      if (!response) {
        console.error(
          '❌ [getEndYearDetail] La respuesta del servicio es null o undefined'
        );
        return {};
      }

      const transformData = await this.transformEndYearDetail(response);

      return transformData;
    } catch (error) {
      console.error(
        '❌ [getEndYearDetail] Error en la petición o transformación:',
        error
      );
      console.error(
        '❌ [getEndYearDetail] Stack trace completo:',
        (error as Error)?.stack
      );
      return {};
    }
  }

  async transformVacationsDetail(data: IResponse) {
    const getYearFromDate = (date: any) => date?.split('-')[0] || '';

    const consumosUDC = data.udc.lastYearConsumptions
      .map((item, index) => {
        // Check if we have a valid prediction for this index
        const prediction = data.udc.periodPredictions[index];
        if (!prediction) {
          console.warn(`No prediction found for index ${index}`);
          return null;
        }

        const lastYear = getYearFromDate(item.date);
        const currentYear = getYearFromDate(prediction.date);

        return {
          [`consumo${lastYear}`]: item.totalMbtu.toFixed(3),
          [`dia${lastYear}`]: this.capitalizeText(item.day),
          [`fecha${lastYear}`]: this.formatDateDetail(item.date),
          [`consumo${currentYear}`]: prediction.totalMbtu.toFixed(3),
          [`dia${currentYear}`]: this.capitalizeText(prediction.day),
          [`fecha${currentYear}`]: this.formatDateDetail(prediction.date),
        };
      })
      .filter(Boolean); // Remove any null entries

    const consumosPudc = this.transformConsumesData(data.pudc);
    const consumosRCDTAC = this.transformRCDTACConsumesData(data.rcdtac);
    const consumosRCUDC = this.transformRCDTACConsumesData(data.rcudc);
    const previousWeeksRCDTAC = this.transformPreviousWeeks(
      data.rcdtac.typicWeeksResult
    );
    const rcRCDTAC = this.transformRCVacationsData(data.rcdtac.rcByYear);
    const rcUdc = this.transformRCVacationsData(data.rcudc.rcByYear);

    const PUDCTypeDays = this.transformTypeDaysData(data.pudc.typeDaysByYear);
    const RCDTACTypeDaysResult = this.transformTypeDaysData(
      data.rcdtac.typeDaysResult
    );
    const rcudcTypeDays = this.transformTypeDaysData(data.rcudc.typeDaysResult);

    return {
      udc: {
        consumos: consumosUDC,
        typeDay: data.udc.typeDayConsumptions,
      },
      pudc: {
        consumos: consumosPudc,
        typeDays: PUDCTypeDays,
      },
      rcdtac: {
        consumos: consumosRCDTAC,
        typeDays: RCDTACTypeDaysResult,
        previousWeek: previousWeeksRCDTAC,
        rc: rcRCDTAC,
      },
      rcudc: {
        consumos: consumosRCUDC,
        typeDays: rcudcTypeDays,
        rc: rcUdc,
      },
    };
  }

  async transformEndYearDetail(data: any) {
    // Validación inicial de la estructura de datos
    if (!data) {
      console.error(
        '❌ [transformEndYearDetail] Los datos de entrada son null o undefined'
      );
      throw new Error('Los datos de entrada no pueden ser null o undefined');
    }

    try {
      const udcConsuptions = this.transformEndYearConsuptionsUDC(data);
      const udcTypicalWeeks = this.transformTypicalWeeksEndYear(
        data.udc?.typeDaysResult
      );

      const pudcConsuptions = this.transformPUDCEndYearConsumptions(
        data.pudc?.consumptionsByYear,
        data.pudc?.predictionResult
      );

      console.log(
        '🔍 [transformEndYearDetail] Llamando transformTypeDaysEndYear para PUDC...'
      );
      const typeDaysPUDC = this.transformTypeDaysEndYear(
        data.pudc?.typeDaysResult
      );

      const holidaysByYearPUDC = this.transformHolidaysByYear(
        data.pudc?.holidays
      );

      // RCDTAC
      const rcdtacConsuptions = this.transformPUDCEndYearConsumptions(
        data.rcdtac?.consumptionsByYear,
        data.rcdtac?.predictionResult
      );

      console.log(
        '🔍 [transformEndYearDetail] Llamando transformTypeDaysEndYear para RCDTAC...'
      );
      const typeDaysRCDTAC = this.transformTypeDaysEndYear(
        data.rcdtac?.typeDaysResult
      );

      const holidaysByYearRCDTAC = this.transformHolidaysByYear(
        data.rcdtac?.holidays
      );
      const previousWeekRCDTAC = this.transformPreviousWeeks(
        data.rcdtac?.typicWeeksResult
      );
      const rcRCDTAC = this.transformRCDataPeriods(data.rcdtac?.rcByPeriod);
      const rcHolidaysRCDTAC = this.transformRCHolidays(
        data.rcdtac?.rcByHolidays
      );

      // RCUDC
      const rcudcConsuptions = this.transformPUDCEndYearConsumptions(
        data.rcudc?.consumptionsByYear,
        data.rcudc?.predictionResult
      );

      console.log(
        '🔍 [transformEndYearDetail] Llamando transformTypeDaysEndYear para RCUDC...'
      );
      const typeDaysRCUDC = this.transformTypeDaysEndYear(
        data.rcudc?.typeDaysResult
      );

      const holidaysByYearRCUDC = this.transformHolidaysByYear(
        data.rcudc?.holidays
      );
      const rcRCUDC = this.transformRCDataPeriods(data.rcudc?.rcByPeriod);
      const rcHolidaysRCUDC = this.transformRCHolidays(
        data.rcudc?.rcByHolidays
      );

      const result = {
        udc: {
          consumos: udcConsuptions,
          typicalWeeks: udcTypicalWeeks,
          holidays: data.udc?.holidays || [],
        },
        pudc: {
          consumos: pudcConsuptions,
          typeDays: typeDaysPUDC,
          holidaysByYear: holidaysByYearPUDC,
        },
        rcdtac: {
          consumos: rcdtacConsuptions,
          typeDaysPeriod: typeDaysRCDTAC,
          holidaysByYear: holidaysByYearRCDTAC,
          previousWeek: previousWeekRCDTAC,
          rcPeriod: rcRCDTAC,
          rcholidaysByYear: rcHolidaysRCDTAC,
        },
        rcudc: {
          consumos: rcudcConsuptions,
          typeDaysPeriod: typeDaysRCUDC,
          holidaysByYear: holidaysByYearRCUDC,
          rcPeriod: rcRCUDC,
          rcholidaysByYear: rcHolidaysRCUDC,
        },
      };

      // Logs detallados del resultado final
      console.log('🔍 [transformEndYearDetail] Resultado final detallado:');
      console.log(
        '🔍 [transformEndYearDetail] UDC consumos length:',
        udcConsuptions?.length || 'undefined'
      );
      console.log(
        '🔍 [transformEndYearDetail] UDC typicalWeeks length:',
        udcTypicalWeeks?.length || 'undefined'
      );
      console.log(
        '🔍 [transformEndYearDetail] PUDC consumos length:',
        pudcConsuptions?.length || 'undefined'
      );
      console.log(
        '🔍 [transformEndYearDetail] PUDC typeDays:',
        typeof typeDaysPUDC,
        Object.keys(typeDaysPUDC || {})
      );
      console.log(
        '🔍 [transformEndYearDetail] RCDTAC consumos length:',
        rcdtacConsuptions?.length || 'undefined'
      );
      console.log(
        '🔍 [transformEndYearDetail] RCUDC consumos length:',
        rcudcConsuptions?.length || 'undefined'
      );
      console.log(
        '🔍 [transformEndYearDetail] Resultado completo estructura:',
        {
          udc: {
            consumos: udcConsuptions?.length || 0,
            typicalWeeks: udcTypicalWeeks?.length || 0,
            holidays: (data.udc?.holidays || []).length,
          },
          pudc: {
            consumos: pudcConsuptions?.length || 0,
            typeDays: typeof typeDaysPUDC,
            holidaysByYear: holidaysByYearPUDC?.length || 0,
          },
          rcdtac: {
            consumos: rcdtacConsuptions?.length || 0,
            typeDaysPeriod: typeof typeDaysRCDTAC,
            holidaysByYear: holidaysByYearRCDTAC?.length || 0,
            previousWeek: previousWeekRCDTAC?.length || 0,
            rcPeriod: typeof rcRCDTAC,
            rcholidaysByYear: rcHolidaysRCDTAC?.length || 0,
          },
          rcudc: {
            consumos: rcudcConsuptions?.length || 0,
            typeDaysPeriod: typeof typeDaysRCUDC,
            holidaysByYear: holidaysByYearRCUDC?.length || 0,
            rcPeriod: typeof rcRCUDC,
            rcholidaysByYear: rcHolidaysRCUDC?.length || 0,
          },
        }
      );

      console.log(
        '✅ [transformEndYearDetail] Transformación completada exitosamente'
      );
      return result;
    } catch (error) {
      console.error(
        '❌ [transformEndYearDetail] Error durante la transformación:',
        error
      );
      console.error(
        '❌ [transformEndYearDetail] Datos que causaron el error:',
        data
      );
      throw error;
    }
  }

  transformRCHolidays(data: any): any[] {
    console.log('🔍 [transformRCHolidays] Entrada de datos:', data);

    if (!data || typeof data !== 'object') {
      console.warn('⚠️ [transformRCHolidays] Datos inválidos o nulos:', data);
      return [];
    }

    const result: any = {};

    try {
      for (const yearRange in data) {
        console.log(`🔍 [transformRCHolidays] Procesando año: ${yearRange}`);

        if (!data[yearRange] || !Array.isArray(data[yearRange])) {
          console.warn(
            `⚠️ [transformRCHolidays] Datos del año ${yearRange} no son un array válido:`,
            data[yearRange]
          );
          continue;
        }

        const yearStart = yearRange.split('-')[0];

        data[yearRange].forEach((holidayData: any) => {
          if (!holidayData) {
            console.warn(
              `⚠️ [transformRCHolidays] Datos de holiday nulos en año ${yearRange}`
            );
            return;
          }

          const { nombre, dia, rc, predictionDate } = holidayData;

          if (!nombre) {
            console.warn(
              `⚠️ [transformRCHolidays] Holiday sin nombre en año ${yearRange}:`,
              holidayData
            );
            return;
          }

          if (!result[nombre]) {
            result[nombre] = { nombre };
          }

          if (typeof rc === 'number') {
            result[nombre][`rc${yearStart}`] = rc.toFixed(2);
          }

          if (predictionDate) {
            result[nombre][`predictionDate${yearStart}`] =
              this.formatDateDetail(predictionDate);
          }

          if (yearStart === '2024' && dia) {
            result[nombre]['dia'] = this.capitalizeText(dia);
          }
        });
      }

      console.log('✅ [transformRCHolidays] Resultado:', Object.values(result));
      return Object.values(result);
    } catch (error) {
      console.error('❌ [transformRCHolidays] Error procesando datos:', error);
      console.error(
        '❌ [transformRCHolidays] Datos que causaron el error:',
        data
      );
      return [];
    }
  }

  transformEndYearConsuptionsUDC(data: any) {
    const transformedData = [];
    const lastYearConsumptions = data.udc.lastYearConsumptions;
    const predictionResult = data.udc.predictionResult;

    function getPeriodYear(dateString: string): string {
      const date = new Date(dateString);
      const year = date.getFullYear();
      return date < new Date(`${year}-01-16`) ? `${year - 1}` : `${year}`;
    }

    for (let i = 0; i < lastYearConsumptions.length; i++) {
      const currentYearItem = lastYearConsumptions[i];
      const nextYearItem = predictionResult[i];

      const periodYear1 = getPeriodYear(currentYearItem.date);
      const periodYear2 = getPeriodYear(nextYearItem.predictionDate);

      transformedData.push({
        [`dia${periodYear1}`]: this.capitalizeText(currentYearItem.dayOfWeek),
        [`fecha${periodYear1}`]: this.formatDateDetail(currentYearItem.date),
        [`consumo${periodYear1}`]: currentYearItem.mbtu.toFixed(2),

        [`dia${periodYear2}`]: this.capitalizeText(nextYearItem.dayOfWeek),
        [`fecha${periodYear2}`]: this.formatDateDetail(
          nextYearItem.predictionDate
        ),
        [`consumo${periodYear2}`]: nextYearItem.mbtu.toFixed(2),
      });
    }

    return transformedData;
  }

  transformPUDCEndYearConsumptions(
    consumptionsByYear: any,
    predictionResult: any
  ) {
    console.log('🔍 [transformPUDCEndYearConsumptions] Entrada de datos:', {
      consumptionsByYear,
      predictionResult,
    });

    if (!consumptionsByYear || typeof consumptionsByYear !== 'object') {
      console.warn(
        '⚠️ [transformPUDCEndYearConsumptions] consumptionsByYear inválido:',
        consumptionsByYear
      );
      return [];
    }

    if (!predictionResult || !Array.isArray(predictionResult)) {
      console.warn(
        '⚠️ [transformPUDCEndYearConsumptions] predictionResult inválido:',
        predictionResult
      );
      return [];
    }

    try {
      const combinedData: any[] = [];
      const referenceDates: any = {};

      function getMonthDay(dateString: string) {
        if (!dateString || typeof dateString !== 'string') return '';
        const [year, month, day] = dateString.split('-');
        return `${month}-${day}`;
      }

      Object.keys(consumptionsByYear).forEach(yearRange => {
        console.log(
          `🔍 [transformPUDCEndYearConsumptions] Procesando año: ${yearRange}`
        );

        const yearData = consumptionsByYear[yearRange];
        if (!yearData || typeof yearData !== 'object') {
          console.warn(
            `⚠️ [transformPUDCEndYearConsumptions] Datos del año ${yearRange} inválidos:`,
            yearData
          );
          return;
        }

        const year = yearRange.split('-')[0];

        Object.entries(yearData).forEach(([date, data]: any) => {
          if (!data) {
            console.warn(
              `⚠️ [transformPUDCEndYearConsumptions] Datos de fecha ${date} nulos en año ${yearRange}`
            );
            return;
          }

          const monthDay = getMonthDay(data.date);
          if (!monthDay) {
            console.warn(
              `⚠️ [transformPUDCEndYearConsumptions] No se pudo obtener month-day de fecha:`,
              data.date
            );
            return;
          }

          if (!referenceDates[monthDay]) {
            referenceDates[monthDay] = {};
          }

          referenceDates[monthDay][`dia${year}`] = data.dayOfWeek
            ? this.capitalizeText(data.dayOfWeek)
            : '-';
          referenceDates[monthDay][`fecha${year}`] = data.date
            ? this.formatDateDetail(data.date)
            : '-';
          referenceDates[monthDay][`consumo${year}`] =
            typeof data.mbtu === 'number' ? data.mbtu.toFixed(2) : '-';
        });
      });

      if (predictionResult.length > 0) {
        const predictionFirstDate = predictionResult[0];
        if (!predictionFirstDate || !predictionFirstDate.predictionDate) {
          console.warn(
            '⚠️ [transformPUDCEndYearConsumptions] Primera fecha de predicción inválida:',
            predictionFirstDate
          );
        } else {
          const yearPrediction =
            predictionFirstDate.predictionDate.split('-')[0];

          Object.entries(predictionResult).forEach(
            ([date, prediction]: any) => {
              if (!prediction) {
                console.warn(
                  `⚠️ [transformPUDCEndYearConsumptions] Predicción nula en índice ${date}`
                );
                return;
              }

              const monthDay = getMonthDay(prediction.predictionDate);
              if (!monthDay) {
                console.warn(
                  `⚠️ [transformPUDCEndYearConsumptions] No se pudo obtener month-day de predicción:`,
                  prediction.predictionDate
                );
                return;
              }

              if (!referenceDates[monthDay]) {
                referenceDates[monthDay] = {};
              }

              referenceDates[monthDay][`dia${yearPrediction}`] =
                prediction.dayOfWeek
                  ? this.capitalizeText(prediction.dayOfWeek)
                  : '-';
              referenceDates[monthDay][`fecha${yearPrediction}`] =
                prediction.predictionDate
                  ? this.formatDateDetail(prediction.predictionDate)
                  : '-';
              referenceDates[monthDay][`consumo${yearPrediction}`] =
                typeof prediction.mbtu === 'number'
                  ? prediction.mbtu.toFixed(2)
                  : '-';
            }
          );
        }
      }

      Object.keys(referenceDates).forEach(monthDay => {
        combinedData.push(referenceDates[monthDay]);
      });

      console.log(
        '✅ [transformPUDCEndYearConsumptions] Resultado:',
        combinedData
      );
      return combinedData;
    } catch (error) {
      console.error(
        '❌ [transformPUDCEndYearConsumptions] Error procesando datos:',
        error
      );
      console.error(
        '❌ [transformPUDCEndYearConsumptions] Datos que causaron el error:',
        {
          consumptionsByYear,
          predictionResult,
        }
      );
      return [];
    }
  }

  transformTypeDaysEndYear(data: any) {
    console.log('🔍 [transformTypeDaysEndYear] Entrada de datos:', data);

    // Validación defensiva para evitar errores con Object.keys
    if (!data || typeof data !== 'object') {
      console.warn(
        '⚠️ [transformTypeDaysEndYear] Datos inválidos o nulos:',
        data
      );
      return {};
    }

    const result: any = {};

    try {
      Object.keys(data).forEach(grupo => {
        console.log(`🔍 [transformTypeDaysEndYear] Procesando grupo: ${grupo}`);

        const groupData = data[grupo];

        // Validación del groupData
        if (!groupData || typeof groupData !== 'object') {
          console.warn(
            `⚠️ [transformTypeDaysEndYear] Datos del grupo ${grupo} inválidos:`,
            groupData
          );
          return; // Skip este grupo
        }

        const groupKeys = Object.keys(groupData);
        if (groupKeys.length === 0) {
          console.warn(
            `⚠️ [transformTypeDaysEndYear] El grupo ${grupo} está vacío`
          );
          return; // Skip este grupo
        }

        const years = groupKeys.map(yearRange => {
          return parseInt(yearRange.split('-')[0]);
        });

        const nextYear = Math.max(...years) + 1;

        const consumptions: any = [];
        const firstGroupData = groupData[groupKeys[0]];

        if (!Array.isArray(firstGroupData)) {
          console.warn(
            `⚠️ [transformTypeDaysEndYear] Los datos del primer año del grupo ${grupo} no son un array:`,
            firstGroupData
          );
          return; // Skip este grupo
        }

        const days = firstGroupData
          .map((dayObj: any) => dayObj?.dia)
          .filter(day => day);

        if (days.length === 0) {
          console.warn(
            `⚠️ [transformTypeDaysEndYear] No se encontraron días válidos en el grupo ${grupo}`
          );
          return; // Skip este grupo
        }

        console.log(
          `✅ [transformTypeDaysEndYear] Grupo ${grupo} - Años: ${years}, Días: ${days.length}`
        );

        days.forEach((day: any, index: number) => {
          const consumptionPerDay: any = {
            dia: this.capitalizeText(day),
          };
          let totalConsumption = 0;
          let count = 0;

          years.forEach((year, yearIndex) => {
            const yearRange = groupKeys[yearIndex];
            const yearData = groupData[yearRange];

            if (Array.isArray(yearData) && yearData[index]) {
              const dayData = yearData[index];

              if (dayData && typeof dayData.mbtu === 'number') {
                totalConsumption += dayData.mbtu;
                count++;
                consumptionPerDay[`consumo${year}`] = dayData.mbtu.toFixed(2);
                consumptionPerDay[`group`] = dayData.grupo;
              } else {
                console.warn(
                  `⚠️ [transformTypeDaysEndYear] Datos del día inválidos en ${grupo}/${year}/${index}:`,
                  dayData
                );
              }
            }
          });

          if (count > 0) {
            const avgConsumption = totalConsumption / count;
            consumptionPerDay[`avg${nextYear}`] = avgConsumption.toFixed(2);
            consumptions.push(consumptionPerDay);
          }
        });

        years.push(nextYear);

        result[grupo] = {
          years: years.sort((a, b) => a - b),
          consumptions,
        };
      });

      console.log('✅ [transformTypeDaysEndYear] Resultado final:', result);
      return result;
    } catch (error) {
      console.error(
        '❌ [transformTypeDaysEndYear] Error procesando datos:',
        error
      );
      console.error(
        '❌ [transformTypeDaysEndYear] Datos que causaron el error:',
        data
      );
      return {};
    }
  }

  transformTypicalWeeksEndYear(data: any) {
    const result = [];

    for (const item of data) {
      let existingDay: any = result.find(
        d => d.day === this.capitalizeText(item.dia)
      );
      if (!existingDay) {
        existingDay = { day: this.capitalizeText(item.dia) };
        result.push(existingDay);
      }
      existingDay[`term${item.grupo}`] = item.mbtu.toFixed(2);
    }

    return result;
  }

  transformHolidaysByYear(data: any) {
    console.log('🔍 [transformHolidaysByYear] Entrada de datos:', data);

    if (!data || typeof data !== 'object') {
      console.warn(
        '⚠️ [transformHolidaysByYear] Datos inválidos o nulos:',
        data
      );
      return [];
    }

    const result: any = {};

    try {
      for (const yearRange in data) {
        console.log(
          `🔍 [transformHolidaysByYear] Procesando año: ${yearRange}`
        );

        if (!data[yearRange] || !Array.isArray(data[yearRange])) {
          console.warn(
            `⚠️ [transformHolidaysByYear] Datos del año ${yearRange} no son un array válido:`,
            data[yearRange]
          );
          continue;
        }

        const yearStart = yearRange.split('-')[0];

        data[yearRange].forEach((holidayData: any) => {
          if (!holidayData) {
            console.warn(
              `⚠️ [transformHolidaysByYear] Datos de holiday nulos en año ${yearRange}`
            );
            return;
          }

          const { nombre, dia, mbtu, predictionDate } = holidayData;

          if (!nombre) {
            console.warn(
              `⚠️ [transformHolidaysByYear] Holiday sin nombre en año ${yearRange}:`,
              holidayData
            );
            return;
          }

          if (!result[nombre]) {
            result[nombre] = { nombre };
          }

          if (typeof mbtu === 'number') {
            result[nombre][`mbtu${yearStart}`] = mbtu.toFixed(2);
          }

          if (predictionDate) {
            result[nombre][`predictionDate${yearStart}`] =
              this.formatDateDetail(predictionDate);
          }

          if (yearStart === '2024' && dia) {
            result[nombre]['dia'] = this.capitalizeText(dia);
          }
        });
      }

      console.log(
        '✅ [transformHolidaysByYear] Resultado:',
        Object.values(result)
      );
      return Object.values(result);
    } catch (error) {
      console.error(
        '❌ [transformHolidaysByYear] Error procesando datos:',
        error
      );
      console.error(
        '❌ [transformHolidaysByYear] Datos que causaron el error:',
        data
      );
      return [];
    }
  }

  transformConsumesData(data: any) {
    // Primero ordenar las predicciones por fecha
    const sortedPredictions = data.predictionResult.sort(
      (a: any, b: any) =>
        new Date(a.predictionDate).getTime() -
        new Date(b.predictionDate).getTime()
    );

    const transformed = sortedPredictions.map(
      (prediction: any, index: number) => {
        const year = prediction.predictionDate.split('-')[0];
        const result = {
          [`dia${year}`]: this.capitalizeText(prediction.dayOfWeek),
          [`fecha${year}`]: this.formatDateDetail(prediction.predictionDate),
          [`consumo${year}`]: prediction.averageMbtu
            ? prediction.averageMbtu.toFixed(3)
            : null,
          [`etiqueta${year}`]: prediction.etiquetaUuid,
        };

        // Para cada año histórico, tomar las fechas en orden cronológico
        Object.keys(data.consumptionsByYear).forEach(year => {
          const datesInYear = Object.keys(data.consumptionsByYear[year]).sort(
            (a, b) => new Date(a).getTime() - new Date(b).getTime()
          );

          // Tomar la fecha correspondiente por índice, no por día de la semana
          if (index < datesInYear.length) {
            const consumptionDate = datesInYear[index];
            const consumptionData =
              data.consumptionsByYear[year][consumptionDate];

            result[`dia${year}`] = this.capitalizeText(
              consumptionData.dayOfWeek
            );
            result[`fecha${year}`] = this.formatDateDetail(consumptionDate);
            result[`consumo${year}`] = consumptionData.mbtu
              ? consumptionData.mbtu.toFixed(3)
              : null;
          }
        });

        return result;
      }
    );

    return transformed;
  }

  transformTypeDays(data: any) {}

  transformPreviousWeeks(data: any) {
    console.log('🔍 [transformPreviousWeeks] Entrada de datos:', data);

    if (!data || typeof data !== 'object') {
      console.warn(
        '⚠️ [transformPreviousWeeks] Datos inválidos o nulos:',
        data
      );
      return [];
    }

    try {
      const result = Object.keys(data).map(year => {
        console.log(`🔍 [transformPreviousWeeks] Procesando año: ${year}`);

        const yearData = data[year];
        if (!yearData || typeof yearData !== 'object') {
          console.warn(
            `⚠️ [transformPreviousWeeks] Datos del año ${year} inválidos:`,
            yearData
          );
          return {
            year: parseInt(year),
            consumptions: [],
          };
        }

        const consumptions = Object.keys(yearData).map(date => {
          const dateData = yearData[date];
          if (!dateData) {
            console.warn(
              `⚠️ [transformPreviousWeeks] Datos de fecha ${date} nulos en año ${year}`
            );
            return {
              dia: '-',
              date: date,
              consumoTypicDay: 0,
            };
          }

          return {
            dia: dateData.dayOfWeek
              ? this.capitalizeText(dateData.dayOfWeek)
              : '-',
            date: this.formatDateDetail(date),
            consumoTypicDay:
              typeof dateData.mbtu === 'number'
                ? parseFloat(dateData.mbtu.toFixed(3))
                : 0,
          };
        });

        return {
          year: parseInt(year),
          consumptions,
        };
      });

      console.log('✅ [transformPreviousWeeks] Resultado:', result);
      return result;
    } catch (error) {
      console.error(
        '❌ [transformPreviousWeeks] Error procesando datos:',
        error
      );
      console.error(
        '❌ [transformPreviousWeeks] Datos que causaron el error:',
        data
      );
      return [];
    }
  }

  transformRCDTACConsumesData(data: any) {
    const transformed = data.predictionResult.map(
      (prediction: any, index: number) => {
        const year = prediction.predictionDate.split('-')[0];
        const result: any = {
          [`dia${year}`]: this.capitalizeText(prediction.dayOfWeek),
          [`fecha${year}`]: this.formatDateDetail(prediction.predictionDate),
          [`etiquetaUuid${year}`]: prediction.etiquetaUuid,
          [`consumo${year}`]: prediction.mbtu
            ? prediction.mbtu.toFixed(3)
            : null,
        };

        for (const prevYear in data.previousConsumptions) {
          if (data.previousConsumptions.hasOwnProperty(prevYear)) {
            const consumptionEntries = Object.entries(
              data.previousConsumptions[prevYear]
            );

            if (index < consumptionEntries.length) {
              const [prevDate, prevData] = consumptionEntries[index] as [
                any,
                ConsumptionsByYear,
              ];
              result[`dia${prevYear}`] = this.capitalizeText(
                prevData.dayOfWeek
              );
              result[`fecha${prevYear}`] = this.formatDateDetail(prevDate);
              result[`etiqueta${prevYear}`] = prevDate.etiquetaUuid;
              result[`consumo${prevYear}`] = prevData.mbtu
                ? prevData.mbtu.toFixed(3)
                : null;
            } else {
              result[`dia${prevYear}`] = '-';
              result[`fecha${prevYear}`] = '-';
              result[`consumo${prevYear}`] = '-';
            }
          }
        }

        return result;
      }
    );

    return transformed;
  }

  transformRCVacationsData(data: any) {
    if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
      return [];
    }

    const result = [];
    const years = Object.keys(data)
      .map(Number)
      .sort((a, b) => b - a);
    const targetYear = years[0] + 1;

    const groupedData = new Map();

    for (const year of years) {
      for (const entry of data[year]) {
        const key = `${entry.dia}-${entry.etiqueta}`;
        if (!groupedData.has(key)) {
          groupedData.set(key, {});
        }
        groupedData.get(key)[year] = entry;
      }
    }

    for (const [key, entries] of groupedData.entries()) {
      const transformItem: any = {};
      let total = 0;
      let count = 0;

      for (const year of years) {
        const entry = entries[year];

        if (entry) {
          transformItem[`dia${year}`] = this.capitalizeText(entry.dia);
          transformItem[`etiqueta${year}`] = entry.etiqueta;
          transformItem[`etiquetaUuid${year}`] = entry.etiqueta;
          transformItem[`consumo${year}`] = entry.rc.toFixed(3);

          const consumo = parseFloat(entry.rc);
          if (!isNaN(consumo)) {
            total += consumo;
            count++;
          }
        } else {
          transformItem[`dia${year}`] = '-';
          transformItem[`etiqueta${year}`] = '-';
          transformItem[`etiquetaUuid${year}`] = '-';
          transformItem[`consumo${year}`] = '-';
        }
      }

      result.push(transformItem);
    }

    return result;
  }

  transformTypeDaysData(data: any) {
    const years = Object.keys(data);
    const groupedData: { [key: string]: { [year: string]: any } } = {};

    for (const year of years) {
      const entries = data[year];

      for (const entry of entries) {
        // U
        const key = `${entry.dia}-${entry.etiquetaUuid}`;

        if (!groupedData[key]) {
          groupedData[key] = {};
        }

        groupedData[key][year] = {
          dia: entry.dia,
          etiqueta: entry.etiquetaName,
          consumo: entry.mbtu ?? entry.consumo,
          etiquetaUuid: entry.etiquetaUuid ?? entry.etiqueta,
        };
      }
    }

    const consumptions = [];
    for (const key in groupedData) {
      const entry = groupedData[key];
      const consumptionData: any = {};

      for (const year of years) {
        if (entry[year]) {
          consumptionData[`dia${year}`] = entry[year].dia;
          consumptionData[`etiqueta${year}`] = entry[year].etiqueta;
          consumptionData[`etiquetaUuid${year}`] = entry[year].etiquetaUuid;
          consumptionData[`consumo${year}`] = entry[year].consumo
            ? entry[year].consumo.toFixed(3)
            : 0;
        } else {
          consumptionData[`dia${year}`] = '-';
          consumptionData[`etiqueta${year}`] = '-';
          consumptionData[`etiquetaUuid${year}`] = '-';
          consumptionData[`consumo${year}`] = '-';
        }
      }

      consumptions.push(consumptionData);
    }

    return { years, consumptions };
  }

  transformRCDataPeriods(data: any) {
    console.log('🔍 [transformRCDataPeriods] Entrada de datos:', data);

    if (!data || typeof data !== 'object') {
      console.warn(
        '⚠️ [transformRCDataPeriods] Datos inválidos o nulos:',
        data
      );
      return {};
    }

    const result: any = {};

    try {
      Object.keys(data).forEach(grupo => {
        console.log(`🔍 [transformRCDataPeriods] Procesando grupo: ${grupo}`);

        const grupoData = data[grupo];

        if (!grupoData || typeof grupoData !== 'object') {
          console.warn(
            `⚠️ [transformRCDataPeriods] Datos del grupo ${grupo} inválidos:`,
            grupoData
          );
          return; // Skip este grupo
        }

        const groupKeys = Object.keys(grupoData);
        if (groupKeys.length === 0) {
          console.warn(
            `⚠️ [transformRCDataPeriods] El grupo ${grupo} está vacío`
          );
          return; // Skip este grupo
        }

        const years = groupKeys.map(yearRange =>
          parseInt(yearRange.split('-')[0])
        );
        const rc: any[] = [];

        const firstGroupData = grupoData[groupKeys[0]];
        if (!Array.isArray(firstGroupData)) {
          console.warn(
            `⚠️ [transformRCDataPeriods] Los datos del primer año del grupo ${grupo} no son un array:`,
            firstGroupData
          );
          return; // Skip este grupo
        }

        const days = firstGroupData
          .map((dayItem: any) => dayItem?.dia)
          .filter(day => day);

        if (days.length === 0) {
          console.warn(
            `⚠️ [transformRCDataPeriods] No se encontraron días válidos en el grupo ${grupo}`
          );
          return; // Skip este grupo
        }

        console.log(
          `✅ [transformRCDataPeriods] Grupo ${grupo} - Años: ${years}, Días: ${days.length}`
        );

        days.forEach((day: string, index: number) => {
          const consumption: any = {
            dia: this.capitalizeText(day),
            group: firstGroupData[index]?.grupo || 0,
          };

          groupKeys.forEach((yearRange: string) => {
            const year = parseInt(yearRange.split('-')[0]);
            const yearData = grupoData[yearRange];

            if (Array.isArray(yearData) && yearData[index]) {
              const rcValue = yearData[index].rc;
              consumption[`rc${year}`] =
                rcValue !== null && !isNaN(rcValue) ? rcValue.toFixed(2) : '-';
            } else {
              consumption[`rc${year}`] = '-';
              console.warn(
                `⚠️ [transformRCDataPeriods] No hay datos RC para ${grupo}/${year}/${index}`
              );
            }
          });

          rc.push(consumption);
        });

        result[grupo] = {
          years,
          rc,
        };
      });

      console.log('✅ [transformRCDataPeriods] Resultado final:', result);
      return result;
    } catch (error) {
      console.error(
        '❌ [transformRCDataPeriods] Error procesando datos:',
        error
      );
      console.error(
        '❌ [transformRCDataPeriods] Datos que causaron el error:',
        data
      );
      return {};
    }
  }

  formatDate(fecha: string) {
    const diasSemana = [
      'Domingo',
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
    ];
    const meses = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ];
    const date = new Date(fecha);
    const diaSemana = diasSemana[date.getUTCDay()];
    const dia = date.getUTCDate();
    const mes = meses[date.getUTCMonth()];
    const año = date.getUTCFullYear();

    return `${diaSemana} ${dia} de ${mes} ${año}`;
  }

  exportPredictionReport(
    fechaInicio: string,
    fechaFin: string,
    filters?: any
  ): Observable<Blob> {
    const url: string = `${this.appSetting.predictionURL}/${
      PREDICTION_SERVICES.CALENDAR_PREDICTION
    }/download/clients?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&${
      filters ? `&${filters}` : ''
    }`;
    // const url: string = `${this.appSetting.consumptionURL}`;

    return this.httpClient.get(url, { responseType: 'blob' });
  }

  exportPredictionReportExitPoints(
    fechaInicio: string,
    fechaFin: string,
    filters?: any
  ): Observable<Blob> {
    const url: string = `${this.appSetting.predictionURL}/${
      PREDICTION_SERVICES.CALENDAR_PREDICTION
    }/download/exit-points?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&${
      filters ? `&${filters}` : ''
    }`;
    // const url: string = `${this.appSetting.consumptionURL}`;

    return this.httpClient.get(url, { responseType: 'blob' });
  }

  downloadPredictionExcelReport(
    fechaInicio: string,
    fechaFin: string,
    filters?: any
  ): void {
    const dialogRef = this.dialog.open(EnovaLoadingComponent, {
      disableClose: true,
      panelClass: 'loading-spinner-panel',
    });

    // Cambiar cliente= a idMedidor= en los filtros
    const processedFilters = filters
      ? filters.replace(/cliente=/g, 'idMedidor=')
      : '';

    this.exportPredictionReport(fechaInicio, fechaFin, processedFilters)
      .pipe(
        finalize(() => {
          dialogRef.close();
        })
      )
      .subscribe({
        next: blob => {
          const link = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.download = `reporte_prediccion_${fechaInicio}_a_${fechaFin}.xlsx`;

          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        },
        error: error => {
          console.error('Error descargando el archivo:', error);
        },
      });
  }

  downloadPredictionExcelReportExitPoints(
    fechaInicio: string,
    fechaFin: string,
    filters?: any
  ): void {
    const dialogRef = this.dialog.open(EnovaLoadingComponent, {
      disableClose: true,
      panelClass: 'loading-spinner-panel',
    });

    this.exportPredictionReportExitPoints(fechaInicio, fechaFin, filters)
      .pipe(
        finalize(() => {
          dialogRef.close();
        })
      )
      .subscribe({
        next: blob => {
          const link = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.download = `reporte_prediccion_${fechaInicio}_a_${fechaFin}.xlsx`;

          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        },
        error: error => {
          console.error('Error descargando el archivo:', error);
        },
      });
  }

  // TODO integrar servicios para teaer la información real

  getGrapData() {
    return [
      { day: '26/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '25/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '24/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '23/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '22/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '21/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '20/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '19/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '18/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '17/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '16/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '15/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '14/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '13/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '12/02/2024', count: Math.floor(Math.random() * 101) },
    ];
  }

  getGridData() {
    return [
      {
        day: 'Lunes',
        date: '26/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: true,
      },
      {
        day: 'Domingo',
        date: '25/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: true,
      },
      {
        day: 'Sábado',
        date: '24/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: true,
      },
      {
        day: 'Viernes',
        date: '23/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: true,
      },
      {
        day: 'Jueves',
        date: '22/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Miercoles',
        date: '21/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Martes',
        date: '20/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Lunes',
        date: '19/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Domingo',
        date: '18/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Sábado',
        date: '17/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Viernes',
        date: '16/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Jueves',
        date: '15/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Miercoles',
        date: '14/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Martes',
        date: '13/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Lunes',
        date: '12/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
    ];
  }

  getGrapDataSeason() {
    return [
      { day: '04/03/2024', count: Math.floor(Math.random() * 101) },
      { day: '03/03/2024', count: Math.floor(Math.random() * 101) },
      { day: '02/03/2024', count: Math.floor(Math.random() * 101) },
      { day: '01/03/2024', count: Math.floor(Math.random() * 101) },
      { day: '29/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '28/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '27/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '26/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '25/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '24/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '23/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '22/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '21/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '20/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '19/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '18/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '17/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '16/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '15/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '14/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '13/02/2024', count: Math.floor(Math.random() * 101) },
      { day: '12/02/2024', count: Math.floor(Math.random() * 101) },
    ];
  }

  getGridDataSeason() {
    return [
      {
        day: 'Domingo',
        date: '03/03/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Sábado',
        date: '02/03/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Viernes',
        date: '01/03/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Jueves',
        date: '29/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Miercoles',
        date: '28/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Martes',
        date: '27/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Lunes',
        date: '26/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Domingo',
        date: '25/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: true,
      },
      {
        day: 'Sábado',
        date: '24/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: true,
      },
      {
        day: 'Viernes',
        date: '23/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: true,
      },
      {
        day: 'Jueves',
        date: '22/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Miercoles',
        date: '21/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Martes',
        date: '20/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Lunes',
        date: '19/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Domingo',
        date: '18/02/2024',
        tag: 'Festivo Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Sábado',
        date: '17/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Viernes',
        date: '16/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Jueves',
        date: '15/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Miercoles',
        date: '14/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Martes',
        date: '13/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Lunes',
        date: '12/02/2024',
        tag: 'Típico',
        UDC: Math.floor(Math.random() * 100000),
        PUDC: Math.floor(Math.random() * 100000),
        RCDTAC: Math.floor(Math.random() * 100000),
        RCUDC: Math.floor(Math.random() * 100000),
        MPP: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
    ];
  }

  getGridDataPrediction() {
    return [
      {
        day: 'Lunes',
        date: '26/02/2024',
        tag: 'Típico',
        percentage: '50%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: true,
      },
      {
        day: 'Domingo',
        date: '25/02/2024',
        tag: 'Festivo Típico',
        percentage: '20%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: true,
      },
      {
        day: 'Sábado',
        date: '24/02/2024',
        tag: 'Festivo Típico',
        percentage: '20%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: true,
      },
      {
        day: 'Viernes',
        date: '23/02/2024',
        tag: 'Festivo Típico',
        percentage: '30%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: true,
      },
      {
        day: 'Jueves',
        date: '22/02/2024',
        tag: 'Festivo Típico',
        percentage: '50%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Miercoles',
        date: '21/02/2024',
        tag: 'Festivo Típico',
        percentage: '0%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Martes',
        date: '20/02/2024',
        tag: 'Típico',
        percentage: '10%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Lunes',
        date: '19/02/2024',
        tag: 'Típico',
        percentage: '10%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Domingo',
        date: '18/02/2024',
        tag: 'Festivo Típico',
        percentage: '10%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Sábado',
        date: '17/02/2024',
        tag: 'Típico',
        percentage: '20%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Viernes',
        date: '16/02/2024',
        tag: 'Típico',
        percentage: '60%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Jueves',
        date: '15/02/2024',
        tag: 'Típico',
        percentage: '80%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Miercoles',
        date: '14/02/2024',
        tag: 'Típico',
        percentage: '50%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Martes',
        date: '13/02/2024',
        tag: 'Típico',
        percentage: '10%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
      {
        day: 'Lunes',
        date: '12/02/2024',
        tag: 'Típico',
        percentage: '40%',
        USME: Math.floor(Math.random() * 100000),
        USMECCD: Math.floor(Math.random() * 100000),
        CGCALLE13: Math.floor(Math.random() * 100000),
        CityGateCalle13ByPass: Math.floor(Math.random() * 100000),
        CGCOTARECEPTORA: Math.floor(Math.random() * 100000),
        CityGateCotaBogotáByPass: Math.floor(Math.random() * 100000),
        CGGUAYMARAL: Math.floor(Math.random() * 100000),
        CityGateGuaymaralByPass: Math.floor(Math.random() * 100000),
        GCSOACHA: Math.floor(Math.random() * 100000),
        CityGateSoachaByPass: Math.floor(Math.random() * 100000),
        TOTALES: Math.floor(Math.random() * 100000),
        isPredicted: false,
      },
    ];
  }

  getUDCGridData() {
    return [
      {
        day: 'Lunes',
        date: '26/02/2024',
        consumo: Math.floor(Math.random() * 100000),
        day2: 'Lunes',
        date2: '26/02/2024',
        consumo2: Math.floor(Math.random() * 100000),
      },
      {
        day: 'Lunes',
        date: '26/02/2024',
        consumo: Math.floor(Math.random() * 100000),
        day2: 'Lunes',
        date2: '26/02/2024',
        consumo2: Math.floor(Math.random() * 100000),
      },
      {
        day: 'Lunes',
        date: '26/02/2024',
        consumo: Math.floor(Math.random() * 100000),
        day2: 'Lunes',
        date2: '26/02/2024',
        consumo2: Math.floor(Math.random() * 100000),
      },
      {
        day: 'Lunes',
        date: '26/02/2024',
        consumo: Math.floor(Math.random() * 100000),
        day2: 'Lunes',
        date2: '26/02/2024',
        consumo2: Math.floor(Math.random() * 100000),
      },
      {
        day: 'Lunes',
        date: '26/02/2024',
        consumo: Math.floor(Math.random() * 100000),
        day2: 'Lunes',
        date2: '26/02/2024',
        consumo2: Math.floor(Math.random() * 100000),
      },
      {
        day: 'Lunes',
        date: '26/02/2024',
        consumo: Math.floor(Math.random() * 100000),
        day2: 'Lunes',
        date2: '26/02/2024',
        consumo2: Math.floor(Math.random() * 100000),
      },
      {
        day: 'Lunes',
        date: '26/02/2024',
        consumo: Math.floor(Math.random() * 100000),
        day2: 'Lunes',
        date2: '26/02/2024',
        consumo2: Math.floor(Math.random() * 100000),
      },
      {
        day: 'Lunes',
        date: '26/02/2024',
        consumo: Math.floor(Math.random() * 100000),
        day2: 'Lunes',
        date2: '26/02/2024',
        consumo2: Math.floor(Math.random() * 100000),
      },
      {
        day: 'Lunes',
        date: '26/02/2024',
        consumo: Math.floor(Math.random() * 100000),
        day2: 'Lunes',
        date2: '26/02/2024',
        consumo2: Math.floor(Math.random() * 100000),
      },
      {
        day: 'Lunes',
        date: '26/02/2024',
        consumo: Math.floor(Math.random() * 100000),
        day2: 'Lunes',
        date2: '26/02/2024',
        consumo2: Math.floor(Math.random() * 100000),
      },
    ];
  }

  getPreviousTypicalWeek() {
    return {
      basicInfo: [
        {
          day: 'Lunes',
          period1: Math.floor(Math.random() * 100000),
          period2: Math.floor(Math.random() * 100000),
          period3: Math.floor(Math.random() * 100000),
          period4: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Martes',
          period1: Math.floor(Math.random() * 100000),
          period2: Math.floor(Math.random() * 100000),
          period3: Math.floor(Math.random() * 100000),
          period4: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Miercoles',
          period1: Math.floor(Math.random() * 100000),
          period2: Math.floor(Math.random() * 100000),
          period3: Math.floor(Math.random() * 100000),
          period4: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Jueves',
          period1: Math.floor(Math.random() * 100000),
          period2: Math.floor(Math.random() * 100000),
          period3: Math.floor(Math.random() * 100000),
          period4: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Sabado',
          period1: Math.floor(Math.random() * 100000),
          period2: Math.floor(Math.random() * 100000),
          period3: Math.floor(Math.random() * 100000),
          period4: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Domingo',
          period1: Math.floor(Math.random() * 100000),
          period2: Math.floor(Math.random() * 100000),
          period3: Math.floor(Math.random() * 100000),
          period4: Math.floor(Math.random() * 100000),
        },
      ],
    };
  }

  getEndOfYearHolidays() {
    return {
      basicInfo: [
        {
          day: 'Lunes',
          holiday: 'Reyes Magos',
          consumption: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Lunes',
          holiday: 'Año nuevo',
          consumption: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Lunes',
          holiday: 'Navidad',
          consumption: Math.floor(Math.random() * 100000),
        },
      ],
    };
  }

  getPreviousTypicalWeekYear() {
    return {
      basicInfo: [
        {
          day: 'Lunes',
          date: '16/12/2023',
          consumption: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Martes',
          date: '17/12/2023',
          consumption: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Miercoles',
          date: '18/12/2023',
          consumption: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Jueves',
          date: '19/12/2023',
          consumption: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Viernes',
          date: '20/12/2023',
          consumption: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Sabado',
          date: '21/12/2023',
          consumption: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Domingo',
          date: '22/12/2023',
          consumption: Math.floor(Math.random() * 100000),
        },
      ],
    };
  }

  getReasonsForChange() {
    return {
      basicInfo: [
        {
          day: 'Lunes',
          date: '16/12/2023',
          consumption: Math.floor(Math.random() * 100) + '%',
        },
        {
          day: 'Martes',
          date: '17/12/2023',
          consumption: Math.floor(Math.random() * 100) + '%',
        },
        {
          day: 'Miercoles',
          date: '18/12/2023',
          consumption: Math.floor(Math.random() * 100) + '%',
        },
        {
          day: 'Jueves',
          date: '19/12/2023',
          consumption: Math.floor(Math.random() * 100) + '%',
        },
        {
          day: 'Viernes',
          date: '20/12/2023',
          consumption: Math.floor(Math.random() * 100) + '%',
        },
        {
          day: 'Sabado',
          date: '21/12/2023',
          consumption: Math.floor(Math.random() * 100) + '%',
        },
        {
          day: 'Domingo',
          date: '22/12/2023',
          consumption: Math.floor(Math.random() * 100) + '%',
        },
      ],
    };
  }

  getEndOfYearHolidaysyear() {
    return {
      basicInfo: [
        {
          day: 'Lunes',
          holiday: 'Reyes Magos',
          consumption: Math.floor(Math.random() * 100000),
        },
        {
          day: 'Lunes',
          holiday: 'Año nuevo',
          consumption: Math.floor(Math.random() * 100000),
        },

        {
          day: 'Lunes',
          holiday: 'Navidad',
          consumption: Math.floor(Math.random() * 100000),
        },
      ],
    };
  }

  // Función para normalizar nombres de días
  private normalizeDayName(day: string): string {
    if (!day || day === '-') return day;

    // Normalizar a minúsculas y agregar acentos faltantes
    const dayMap: { [key: string]: string } = {
      lunes: 'lunes',
      martes: 'martes',
      miércoles: 'miércoles',
      miercoles: 'miércoles',
      jueves: 'jueves',
      viernes: 'viernes',
      sábado: 'sábado',
      sabado: 'sábado',
      domingo: 'domingo',
    };

    const normalizedDay = day.toLowerCase().trim();
    return dayMap[normalizedDay] || normalizedDay;
  }
}
